<template>
  <div class="training-trend">
    <div class="trend-type">
      <div
        v-for="(item, index) in typeArray"
        :key="index"
        :class="['type-item', curType == index ? 'cur-type' : '']"
        @click="onTypeClick(index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="trend-tab">
      <div
        :class="['tab-item', curIndex == 1 ? 'cur-item' : '']"
        @click="onTabClick(1)"
      >
        日
      </div>
      <div
        :class="['tab-item', curIndex == 2 ? 'cur-item' : '']"
        @click="onTabClick(2)"
      >
        月
      </div>
    </div>
    <div class="info">
      <div
        class="change-num"
        :class="{ 'change-num-down': format(detailInfo.contrast) }"
      >
        <span v-if="parseFloat(detailInfo.contrast) != 0">{{
          format(detailInfo.contrast) ? '-' : '+'
        }}</span>
        {{
          parseFloat(detailInfo.contrast) == 0
            ? '—'
            : format(detailInfo.contrast)
            ? String(detailInfo.contrast).split('-')[1]
            : detailInfo.contrast
        }}
        <span class="change-unit" v-if="parseFloat(detailInfo.contrast) != 0">{{
          detailInfo.unit
        }}</span>
      </div>
      <div class="desc">
        <!-- <div class="title">{{typeArray[curType].name}}</div> -->
        <div class="before">
          初始{{ typeArray[curType].name }}：
          <span>{{ detailInfo.befor }}{{ detailInfo.unit }}</span>
        </div>
        <div class="cur">
          当前{{ typeArray[curType].name }}：
          <span>{{ detailInfo.now }}{{ detailInfo.unit }}</span>
        </div>
      </div>
    </div>
    <div class="unit">
      <span class="dot"></span>
      单位（{{ detailInfo.unit }}）
      <span class="text"
        >上次体测时间: {{ detailInfo.day ? detailInfo.day : '-' }}天前</span
      >
    </div>
    <div class="c-region">
      <div id="CircleChart" style></div>
    </div>
    <img
      class="logo"
      src="https://cdnvue.gymcity.com.cn/uploads/pub-caise-logo"
      alt
    />
  </div>
</template>

<script>
import HighCharts from 'highcharts'
import '@/assets/font/font.css'
export default {
  name: 'training-trend',
  data() {
    return {
      curIndex: 1,
      curType: 0,
      typeArray: [
        {
          name: '体重',
          index: 0
        },
        {
          name: '腰围',
          index: 1
        },
        {
          name: '体脂率',
          index: 2
        },
        {
          name: '胸围',
          index: 3
        },
        {
          name: '臀围',
          index: 4
        },
        // {
        //   name: "腰臀比",
        //   index: 5
        // },
        // {
        //   name: "骨骼肌",
        //   index: 6
        // },
        {
          name: '基础代谢',
          index: 7
        },
        {
          name: 'BMI',
          index: 8
        }
      ],
      detailInfo: {
        befor: 0,
        contrast: 0,
        unit: '',
        now: 0,
        day: 0,
        data: []
      },
      userid: ''
    }
  },
  methods: {
    format(val) {
      return String(val).slice(0, 1) === '-'
    },
    /**
     * 点击趋势种类
     */
    onTypeClick(index) {
      this.curType = index
      this.getTestInfo()
    },
    /**
     * 点击时间
     */
    onTabClick(i) {
      this.curIndex = i
      this.getTestInfo()
    },
    /**
     * 获取趋势信息
     */
    getTestInfo() {
      const that = this
      this.$toast.loading('获取信息中···')
      this.$http
        .post('member/test', {
          a: 'getMemberTestDetail',
          userid: this.userid,
          new: this.$route.query.new || 0,
          type: this.typeArray[this.curType].index,
          date: this.curIndex === 1 ? 'day' : 'month'
        })
        .then((res) => {
          // console.log("info", res);
          if (res.data.code === 200) {
            this.detailInfo = res.data.data
            this.$nextTick(() => {
              let c = []
              let a = []
              res.data.data.data.map((v) => {
                c.push(v[0])
                a.push(Number(v[1]))
              })
              let s = {
                name: this.typeArray[this.curType].name,
                data: a
              }
              that.setCharts(c, s)
            })
          } else {
            this.$dialog.alert({ message: res.data.msg })
          }
          this.$toast.clear()
        })
        .catch((err) => {
          this.$dialog.alert({ message: '网络错误' })
          this.$toast.clear()
        })
    },
    setCharts(c, s) {
      const _this = this
      HighCharts.chart('CircleChart', {
        chart: {
          type: 'area',
          followTouchMov: false,
          zoomType: 'x',
          panning: true
        },
        colors: [
          !_this.format(_this.detailInfo.contrast) ? '#f7b4ca' : '#c7efd4'
        ],
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        xAxis: {
          categories: c,
          tickmarkPlacement: 'on',
          gridLineColor: '#ddd', // 网格线颜色
          gridLineDashStyle: 'dash',
          gridLineWidth: 0.5,
          tickAmount: c.length,
          title: {
            // enabled: false
          }
        },
        yAxis: {
          // visible: false, // 隐藏
          title: {
            text: '十亿',
            enabled: false
          },
          gridLineColor: '#f1f1f1', // 网格线颜色
          gridLineWidth: 0.5,
          labels: {
            formatter: function () {
              // return this.value / 1000;
              return ''
            }
          }
        },
        tooltip: {
          split: false,
          followTouchMove: false,
          valueSuffix: ' ' + _this.detailInfo.unit
        },
        plotOptions: {
          area: {
            dataLabels: {
              enabled: true
            },
            stacking: 'normal',
            lineColor: !_this.format(_this.detailInfo.contrast)
              ? '#dc0050'
              : '#35c763',
            lineWidth: 2,
            marker: {
              lineWidth: 2,
              lineColor: !_this.format(_this.detailInfo.contrast)
                ? '#dc0050'
                : '#35c763',
              fillColor: '#fff'
            },
            // 渐变色
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1
              },
              stops: [
                [
                  0,
                  !_this.format(_this.detailInfo.contrast)
                    ? '#f7b4ca'
                    : '#c7efd4'
                ],

                [
                  1,
                  !_this.format(_this.detailInfo.contrast)
                    ? '#f7b4ca00'
                    : '#c7efd400'
                ] // 这里就是设置渐变色的代码
              ]
            }
          }
        },
        series: [s]
      })
    }
  },
  created() {
    this.curType = this.$route.query.type || 0
    // this.typeArray 为数组 去掉下标5 6 后 大于6的下标缩进
    if (this.curType >= 7) {
      this.curType -= 2
    }
    this.userid = this.$route.query.uid || ''
    // 把参数参入的项放到第一位
    let temp = this.typeArray
    let cur = temp[this.curType]
    temp.splice(this.curType, 1)
    temp.unshift(cur)
    this.typeArray = temp
    this.curType = 0
    this.getTestInfo()
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.training-trend {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  color: #000;
  font-family: PingFang SC;
  background-color: #fff;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 12;
  overflow: auto;
  div::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .trend-tab {
    width: fit-content;
    margin: 0 auto;
    height: 8.5vw;
    background-color: #fff;
    margin-top: 5.7vw;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    border-radius: 1.6vw;
    overflow: hidden;
    .tab-item {
      width: 22.5vw;
      height: 8.5vw;
      font-size: 3.5vw;
      color: #000;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      border: solid 0.5vw #f1f1f1;
    }
    .cur-item {
      color: #fff;
      font-weight: 600;
      background-color: #dc0050;
      border: none;
    }
  }
  .info {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: vw(64) 0;
    .change-num {
      font-size: 12.8vw;
      font-family: Din;
      font-weight: 600;
      color: #dc0050;
      margin-right: 10.4vw;
      .change-unit {
        font-size: 3.2vw;
      }
    }
    .change-num-down {
      color: #35c763;
    }
    .desc {
      // display: flex;
      // flex-direction: column;
      .title {
        font-size: vw(44);
        color: #333;
        font-weight: 550;
        margin-bottom: vw(10);
      }
      .before,
      .cur {
        color: #000;
        font-size: 3.2vw;
        span {
          font-family: Din;
          font-weight: 600;
          font-size: 3.7vw;
        }
      }
    }
  }
  .unit {
    width: 100%;
    padding: 0 vw(32);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    font-size: vw(26);
    color: #666;
    .dot {
      width: vw(10);
      height: vw(10);
      background-color: #dc0050;
      border-radius: 50%;
      margin-right: vw(6);
    }
    .text {
      margin-left: vw(26);
      font-size: vw(20);
      color: #bbb;
    }
  }
  .c-region {
    width: 100%;
    overflow: auto;
    position: relative;
    // display: flex;
    // justify-content: center;
    #CircleChart {
      width: 100vw;
      height: 36vh;
      margin: 0 auto;
    }
  }
  .logo {
    width: vw(293);
    // opacity: .6;
    margin-top: vw(50);
  }
  .trend-type {
    width: 100%;
    padding: 0 2.8vw;
    height: 12.8vw;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
    overflow-x: auto;
    background-color: #fff;
    font-size: 3.7vw;
    white-space: nowrap;
    border-bottom: 2.7vw solid #f7f7f7;
    .type-item {
      display: inline-block;
      font-size: 3.2vw;
      color: rgba(0, 0, 0, 0.5);
      position: relative;
      min-width: 16vw;
      text-align: center;
    }
    .cur-type {
      color: #000;
      font-weight: 600;
    }
    .cur-type::after {
      content: '';
      width: 8vw;
      height: 0.8vw;
      background-color: #dc0050;
      position: absolute;
      bottom: -2vw;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
<style>
.highcharts-credits {
  display: none !important;
}
</style>
